/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoCoordinateDto } from './geoCoordinateDto';

export interface BoundaryDto {
  boundary?: Array<GeoCoordinateDto>;
  holes?: Array<Array<GeoCoordinateDto>>;
}
